/**
 * Remove all HTML tags from a string
 * 
 * @param {String} str
 * @return String
 */
export default function(str){
    return str.replace(/<(.|\n)*?>/g, '');
};